import { render, staticRenderFns } from "./shield-user.vue?vue&type=template&id=69c5c42f&"
import script from "./shield-user.vue?vue&type=script&lang=js&"
export * from "./shield-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69c5c42f')) {
      api.createRecord('69c5c42f', component.options)
    } else {
      api.reload('69c5c42f', component.options)
    }
    module.hot.accept("./shield-user.vue?vue&type=template&id=69c5c42f&", function () {
      api.rerender('69c5c42f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/shield-user.vue"
export default component.exports